import React from "react";
import { Form } from "@ant-design/compatible";
import { FormComponentProps } from "@ant-design/compatible/lib/form";
import { SupplierFormValues } from "@templates/ZSuppliers/ZDrawers/ZAddOrEditSupplier/interface";
import { Document } from "@/Contracts/Documents";
import {
	AddQuoteProductCatalogDrawerFormValues,
	EditQuoteProductCatalogDrawerFormValues,
	QuoteProduct
} from "@/Contracts/ProposalBuilder/Block";
import { Supplier } from "@/Contracts/Settings";
import { RadioChangeEvent } from "antd/es/radio";
import "./../ConfigureDocumentProductDrawer.less";
import DocumentProductConfigureDrawerFormFuncComp from "./DocumentProductConfigureDrawerFormFuncComp";
import DocumentProductConfigureDrawerFormClassComp from "./DocumentProductConfigureDrawerFormClassComp";
import { useFeatureFlag } from "@/Hooks";

export interface Props extends FormComponentProps<QuoteProduct> {
	onClose?: (e: any) => void;
	readonly okText: string;
	readonly defaultData:
		| AddQuoteProductCatalogDrawerFormValues
		| EditQuoteProductCatalogDrawerFormValues
		| null;
	readonly onSubmit?: (quoteProduct: QuoteProduct) => void;
	readonly currentActiveDocument: Document | null;
	readonly isAddingProduct?: boolean;
	readonly isBundleProduct?: boolean;
	readonly hasEditProductCostPricePermission?: boolean;
	readonly isNotABundleProduct?: boolean;
	readonly isSupplierManagementEnabled?: boolean;
	readonly isSupplierSubmitting?: boolean;
	readonly getSuppliers?: () => void;
	readonly getSupplierById?: (supplierId?: string) => void;
	readonly addSupplier?: (
		supplierValues: SupplierFormValues
	) => Promise<Supplier | undefined>;
	readonly isReadOnly?: boolean;
}

export interface IHandlePricingIdChangeProps {
	value: string | null;
	radioChangeEvent: RadioChangeEvent | null;
}

const DocumentProductConfigureDrawerForm: React.FC<Props> = props => {
	const document_roduct_configure_drawer_form_func = useFeatureFlag(
		"document_roduct_configure_drawer_form_func"
	);

	return document_roduct_configure_drawer_form_func ? (
		<DocumentProductConfigureDrawerFormFuncComp {...props} />
	) : (
		<DocumentProductConfigureDrawerFormClassComp {...props} />
	);
};

const ConnectedDocumentProductConfigureDrawerForm = Form.create<Props>({
	name: "configure_document_product_catalog_form"
})((props: Props) => {
	return (
		<DocumentProductConfigureDrawerForm
			{...props}
			isReadOnly={props.isReadOnly ?? false}
		/>
	);
});

export default ConnectedDocumentProductConfigureDrawerForm;
